import React, {useEffect, useRef, useState} from 'react'
import './style.scss'
import '../../assets/style/main.css'
import CROSS_ICON from "../../assets/images/icons/x.png"
import CHECKMEMBER_ICON from '../../assets/images/icons/checkmember-icon.png'
import NH_CONNECT_ICON from '../../assets/images/icons/nh-connect.png'
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from '../../utils/Encryption';
import $ from 'jquery'
import { Base_API } from '../../_actions/matcher'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import useLineLogin from '../../_actions/authLine/lineLogin'
import { NhealthAction } from '../../_actions/action.api'
import { JWTAuthen, SignInPhone, getJWT, getJWTbyPatientID, getPatient, patientVerifySignIn } from '../../_actions/sso.authen'
import { getMemberLab, getMemberNonLab, isMembership, isMembershipNonLab } from '../../_actions/lineoa.authen'
import { useNavigate } from 'react-router-dom'

function SignIn_CheckMember() {
    let onceMount = useRef(true);
    const navigateLink = useNavigate();
    
    const [isMember, setIsMember] = useState(false);
    const [msgStatus, setMsgStatus] = useState("กำลังตรวจสอบ");    

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false; 
        }
    }, [])

    const pageInit = async() => {
        await checkCurrentURL();
        isPageLoading(false);

        //! Bypass
        // let member = {Phoneno: '0655141667'}
        await userHandler();
    }

    const userHandler = () => {
        return new Promise(async resolve => {
            let isMember = await isMembership();
            let isMemberNonLab = await isMembershipNonLab();
            console.log('is membership: ', isMember);
            console.log('is membership nonlab: ', isMemberNonLab);
            if(isMember === true) // member lab
            {
                //! Bypass
                let member = await getMemberLab(); // line oa
                // member.Phoneno = '0830174167';
                let jwt = await JWTAuthen(); // sso
                let userRes = await SignInPhone(jwt, member.Phoneno); // sso
                console.log('member: ', member);
                console.log('userRes: ', userRes);
                
                let jwtData = await JWTAuthen(); // sso
                // set 
                let enc_res = EncryptedOBJ(userRes);
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, enc_res)
                if(userRes.isType === 1)
                {
                    // await checkCameraPermission();

                    setMsgStatus("ยังไม่ได้ลงทะเบียน");
                    $('.submit').fadeIn();
                    resolve();
                } 
                else if(userRes.isType === 2)
                {
                    setMsgStatus("กำลังเชื่อมต่อระบบ");
    
                    let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                    let udid = lineProfile.user_id;
    
                    let headers = {
                        token: jwtData.token,
                        userRef: udid,
                        authorizeRef: jwtData.authorizeRef,
                        channalRef: jwtData.channalRef
                    }
                    let rawReq = {
                        "refEXP": userRes.refEXP,
                        "isType": userRes.isType,
                        "refAction": userRes.refAction,
                        "refType": userRes.refType,
                    }
                    let reqData = {
                        data: EncryptedOBJ(rawReq)
                    }
                    let verifyData = await patientVerifySignIn(reqData, headers)
                    let jwtPatient = await getJWTbyPatientID(verifyData.patientid);
                    console.log('Verify SignIn: ', verifyData);
                    console.log('jwt patient: ', jwtPatient);
                    
                    let headers_2 = {
                        token: jwtPatient.token,
                        userRef: verifyData.patientid,
                        authorizeRef: jwtPatient.authorizeRef,
                        channalRef: jwtPatient.channalRef
                    }
                    let rawReq_2 = {
                        "refEXP": verifyData.refEXP,
                        "isType": verifyData.isType,
                        "refAction": verifyData.refAction,
                        "refType": verifyData.refType,
                    }
                    let reqData_2 = {
                        data: EncryptedOBJ(rawReq_2)
                    }
    
                    await getPatient(reqData_2, headers_2)
                    .then(() => {
                        let callbackURL = `${Base_API.pathWeb}/n-health/signup/success`;
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_CALLBACKURL_PRIVACY_POLICY, EncryptedText(callbackURL))
                        location.href = `${Base_API.pathWeb}/n-health/signin/privacy-policy`;
                    })
    
                } 
                else if(userRes.isType === 3)
                {
                    let callbackURL = `${Base_API.pathWeb}/n-health/signup/success`;
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_CALLBACKURL_PRIVACY_POLICY, EncryptedText(callbackURL))
                    location.href = `${Base_API.pathWeb}/n-health/signin/otp`;
                }
            }else
            {
                if(isMemberNonLab === true)
                {
                    let member = await getMemberNonLab(); // line oa
                    console.log('member: ', member);
                    let jwt = await JWTAuthen(); // sso
                    let userRes = await SignInPhone(jwt, member.Phoneno); // sso
                    console.log('userRes: ', userRes);
                    
                    let jwtData = await JWTAuthen(); // sso
                    // set 
                    let enc_res = EncryptedOBJ(userRes);

                    await regisMemberLab(member)
                    .then(async() => {
                        console.log('member: ', member);
                        console.log('userRes: ', userRes);
                        
                        let jwtData = await JWTAuthen(); // sso
                        // set 
                        let enc_res = EncryptedOBJ(userRes);
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, enc_res)
                        if(userRes.isType === 1)
                        {
                            setMsgStatus("ยังไม่ได้ลงทะเบียน");
                            $('.submit').fadeIn();
                            resolve();
                        } 
                        else if(userRes.isType === 2)
                        {
                            setMsgStatus("กำลังเชื่อมต่อระบบ");
            
                            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                            let udid = lineProfile.user_id;
            
                            let headers = {
                                token: jwtData.token,
                                userRef: udid,
                                authorizeRef: jwtData.authorizeRef,
                                channalRef: jwtData.channalRef
                            }
                            let rawReq = {
                                "refEXP": userRes.refEXP,
                                "isType": userRes.isType,
                                "refAction": userRes.refAction,
                                "refType": userRes.refType,
                            }
                            let reqData = {
                                data: EncryptedOBJ(rawReq)
                            }
                            let verifyData = await patientVerifySignIn(reqData, headers)
                            let jwtPatient = await getJWTbyPatientID(verifyData.patientid);
                            console.log('Verify SignIn: ', verifyData);
                            console.log('jwt patient: ', jwtPatient);
                            
                            let headers_2 = {
                                token: jwtPatient.token,
                                userRef: verifyData.patientid,
                                authorizeRef: jwtPatient.authorizeRef,
                                channalRef: jwtPatient.channalRef
                            }
                            let rawReq_2 = {
                                "refEXP": verifyData.refEXP,
                                "isType": verifyData.isType,
                                "refAction": verifyData.refAction,
                                "refType": verifyData.refType,
                            }
                            let reqData_2 = {
                                data: EncryptedOBJ(rawReq_2)
                            }
            
                            await getPatient(reqData_2, headers_2)
                            .then(() => {
                                let callbackURL = `${Base_API.pathWeb}/n-health/signup/success`;
                                localStorage.setItem(process.env.REACT_APP_ENC_NAME_CALLBACKURL_PRIVACY_POLICY, EncryptedText(callbackURL))
                                location.href = `${Base_API.pathWeb}/n-health/signin/privacy-policy`;
                            })
            
                        } 
                        else if(userRes.isType === 3)
                        {
                            let callbackURL = `${Base_API.pathWeb}/n-health/signin/otp`;
                            localStorage.setItem(process.env.REACT_APP_ENC_NAME_CALLBACKURL_PRIVACY_POLICY, EncryptedText(callbackURL))
                            location.href = `${Base_API.pathWeb}/n-health/signin/privacy-policy`;
                        }
                    })
                    // onSubmit();
                }else
                {
                    // await checkCameraPermission();
                    onSubmit();
                    // location.reload();
                }
            }
        })
    }

    const regisMemberLab = (data) => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;

            let reqData = {
                Firstname: data.Firstname,
                Lastname: data.Lastname,
                Birthday: data.Birthday,
                Phoneno: data.Phoneno,
                Email: data.Email,
                line_display: lineProfile.display_name,
                line_profile: lineProfile.picture_url,
                line_user: lineProfile.user_id,
                line_token: lineProfile.id_token,
                isinvite: false,
                invite_line_user: "",
            }

            NhealthAction.RegisMember(reqData)
            .then(res => {
                console.log("register card member: ", res);
                if(res.isSuccess === true)
                {
                    resolve();
                }else
                {
                    openAlert('ไม่สำเร็จ', res.errMessage, 'ตกลง');
                    //! bypass
                    // resolve(); // พี่นุ๊กเอา verify otp ในเส้น regis card member ออก ให้เอาตรงนี้ออกไป
                }
            })

            resolve();
        })
    }

    async function checkCameraPermission() {
        return new Promise(async resolve => {
            if(!!navigator.permissions)
            {
                resolve();
            }else
            {
                console.log('Camera is not Support this device!');
                let callbackURLEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL)
                console.log("callbackURLEnc: ", callbackURLEnc);
                if(!!callbackURLEnc)
                {
                    let callbackURLDec = DecryptedText(callbackURLEnc);
                    console.log('callbackURLDec: ', callbackURLDec);
                    if(callbackURLDec.indexOf('/ref') >= 0)
                    {
                        let refRedirect = !!localStorage.getItem('refredirect') ? DecryptedText(localStorage.getItem('refredirect')) : null;
                        let newCallbackURL = callbackURLDec.replace('/ref', `/${refRedirect}`)
                        let path = newCallbackURL+"/?openExternalBrowser=1";
                        openExternalLink(path);
                        // resolve();
                    }else
                    {
                        let path = callbackURLDec+"/?openExternalBrowser=1";
                        openExternalLink(path);
                        // resolve();
                    }
                }
            }
        })
    }

    function openExternalLink(url) {
        console.log('open external link: ', url);
        window.location.href = url;
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let cameFromURL = !!localStorage.getItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL)) : null;
            if(!!cameFromURL){
                let matchURL1 = String(`${Base_API.pathWeb}/n-health/signin/privacy-policy`).toLowerCase().replace(/\//g, '');
                let matchURL2 = String(`${Base_API.pathWeb}/n-health/signup/privacy-policy`).toLowerCase().replace(/\//g, '');
                cameFromURL = String(cameFromURL).toLowerCase().replace(/\//g, '');
                if(cameFromURL === matchURL1 || cameFromURL === matchURL2){
                    localStorage.removeItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL);
                    location.reload();
                }
            }

            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));

            resolve();
        })
    }

    const onSubmit = () => {
        let callbackURL = `${Base_API.pathWeb}/n-health/signup/overview`;
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_CALLBACKURL_PRIVACY_POLICY, EncryptedText(callbackURL))
        location.href = `${Base_API.pathWeb}/n-health/signin/overview`;
    }

    return (
        <div className='sgn_checkmember_con'>
            <div className="nav">
                <div className="close">
                    <img src={CROSS_ICON} />     
                </div> 
            </div>

            <div className="header">
                <div className="left">
                    <img src={CHECKMEMBER_ICON} />
                </div>
                <div className="mid">
                    <div className="loading">
                    </div>
                </div>
                <div className="right">
                    <img src={NH_CONNECT_ICON} />
                </div>
            </div>

            <div className="title-wrap">
                <h2>
                    {msgStatus}
                </h2>
                <p>
                    ระบบกำลังตรวจสอบข้อมูลของท่าน เพื่อเข้าใช้บริการ N Health
                </p>
            </div>

            <div className="submit">
                <button onClick={onSubmit}>
                    ลงทะเบียน
                </button>
            </div>

            <div className="copyright">
                <p>© All Rights Reserved. N Health. Managed <br/> by NiLECON THAILAND.</p>
            </div>
            
            <PageLoader />
        </div>
    )
}

export default SignIn_CheckMember